<template>
  <div class="region-point-legend-container scroll-y"
    v-if="checkLegendShowFlag"
  >
    <!-- <el-scrollbar :max-height="300"> -->
      <div class="region-point-legend-item"
        v-for="(legend, index) in iconLegendList"
        :key="index"
      >
        <el-divider v-if="legend['type'] == 'divider'"/>
        <template v-else>
          <svg-icon :iconName="legend['iconName']" :fillColor="legend['fill']"></svg-icon>
          <span>
            {{ legend['name'] }}
          </span>
        </template>
      </div>
      <div
        class="region-point-legend-item"
        v-for="(image, index) in imageLegendList"
        :key="index"
      >
        <img :src="require(`@/assets/leaflet/target-icon/default/${image['fileName']}.png`)" >
        <span>
          {{ image['name'] }}
        </span>
      </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';
// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

const imageIconFolder = require.context(`@/assets/leaflet/target-icon/default`);
const toolControlComSet = computed(()=> store.getters['toolControl/getToolControlComSet'] ),
      checkLegendShowFlag = computed(()=>{
       return Array.isArray(toolControlComSet.value) 
        ? toolControlComSet.value.some(item => item.belongTo == 1)
        : false;
      })
const iconLegendList = [
  { name: '点位无消息', iconName: 'legend-circle', fill: 'rgb(42, 99, 226)', },
  { name: '点位有消息', iconName: 'legend-circle', fill: 'rgb(235, 74, 53)', },
  { name: '推送位点', iconName: 'legend-circle', fill: 'rgb(63, 63, 63)', },
  { type: 'divider' },
  { name: 'NOTAM', iconName: 'legend-circle', fill: 'rgb(95, 180, 112)', },
  { type: 'divider' },
  { name: 'GPS重度干扰（10% ~ 100%）', iconName: 'legend-hexagon', fill: 'rgb(236, 130, 108)', },
  { name: 'GPS轻度干扰（2% ~ 10%）', iconName: 'legend-hexagon', fill: 'rgb(207, 184, 221)', },
  { type: 'divider' },
],
imageLegendList = ref(
  imageIconFolder.keys().map(e=>{
    const name = e.replaceAll('./', '').replaceAll('.png', '');
    return {
      name,
      fileName: name,
    }
  })
)

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.region-point-legend-container{
  position: absolute;
  bottom: calc(var(--bottomControlHeight) + 10px * 2);
  right: 10px;
  // width: max-content;
  width: 200px;
  max-height: 300px;
  border-radius: var(--borderRadiusSize_2);
  box-shadow: var(--boxShadow);
  background: var(--backgroundColor_2);
  border: 1px solid var(--borderColor_9);
  padding: 10px;
  backdrop-filter: blur(15px);
  .region-point-legend-item{
    line-height: 30px;
    .el-divider{
      margin: 5px 0;
      border-width: 2px;
      border-color: rgb(195, 195, 195);
    }
    .svg-icon, img{
      vertical-align: text-bottom;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    span{
      color: var(--fontColor_5);
      font-size: 15px;
      font-family: OPPOSans-B;
    }
  }
}
</style>